import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

interface CardOnFileResponse {
  success?: boolean;
  message?: string;
  error?: {
    message?: string;
  };
}

export async function cardOnFile(cartKey: string, cardKey: string, loginKey: string) {
  return post<CardOnFileResponse>(API_ENDPOINTS.CARD_ON_FILE, {
    cart_key: cartKey,
    card_key: cardKey,
    login_key: loginKey,
  });
}

export default {
  cardOnFile,
};
